<template>


    <div>


      <div v-if="Type==1">
        <div class="ColGroupBlock" :style="gridParams">
        <div class="TitleBlock" v-if="this.header">
          {{this.Message}}
        </div>
        </div>
      </div>
      <div v-if="Type==2">
        <div class="ColGroupBlock2" :style="gridParams">
        <div class="TitleBlock2" v-if="this.header">
          {{this.Message}}
        </div>
        </div>
      </div>
      <div v-if="Type==3">
        <div class="ColGroupBlock3" :style="gridParams">
        <div class="TitleBlock3" v-if="this.header">
          {{this.Message}}
        </div>
      </div>
      </div>
      <!-- {{this.ColStart}}x{{this.ColEnd}}|{{this.RowStart}}x{{this.RowEnd}} -->
    </div>


</template>


<style lang="css" type="text/css">

.ColGroupBlock {
  position: absolute;
  display: flex;
  left: var(--ColStart);
  top: var(--RowStart);
  width: var(--Width);
  height: var(--Height);
  border-right: 1px solid #003950;

  /* grid-column: col var(--ColStart)/var(--ColEnd);
  grid-row: row  var(--RowStart)/var(--RowEnd); */
}

.ColGroupBlock2 {
  position: absolute;
  display: flex;

  left: var(--ColStart);
  top: var(--RowStart);
  width: var(--Width);
  height: var(--Height);
  border-right: 1px solid #0039500d;

  /* grid-column: col var(--ColStart)/var(--ColEnd);
  grid-row: row  var(--RowStart)/var(--RowEnd); */
}

.ColGroupBlock3 {
  left: var(--ColStart);
  top: var(--RowStart);
  width: var(--Width);
  height: var(--Height);
  /* border: 1px solid #003950; */

  /* grid-column: col var(--ColStart)/var(--ColEnd);
  grid-row: row  var(--RowStart)/var(--RowEnd); */
}

.TitleBlock {
  position: relative;
  border: 1px solid #003950;
  background-color: #f1f1f1;
  color: #003950;
  border-radius: 0px;
  padding: 1px;
  font-size: 100%;
  text-align: center;
  font-weight: bolder;

  left: 1;
  top: 1;
  width: var(--Width);
  height: 15px;
}

.TitleBlock2 {
  position: relative;
  border: 1px 1px 1px 1px solid  #003950;
  /* background-color: #003950; */
  color: #003950;
  border-radius: 0px;
  padding: 0px;
  font-size: 100%;
  text-align: center;
  left: 1;
  top: 1;
  width: var(--Width);
  height: 15px;
}

.TitleBlock3 {
  position: relative;
  /* border: 0px solid #ffffff; */
  /* background-color: #003950; */
  color: #003950;
  /* border-radius: 0px; */
  padding: 0px;
  font-size: 55%;

  left: 1;
  top: 1;
  width: var(--Width);
  height: 15px;
}
</style>

<script>


export default {
  name: 'TimelineGridColGroup',
  components: {

  },
	props: {
    ColStart: {
      default: 1
    },
    ColEnd: {
      default: 10
    },
    RowStart: {
      default: 1
    },
    RowEnd: {
      default: 10
    },
    Message: {
      default: "I am a message"
    },
    Type: {
      default: 1
    },
    startdate: {

    },
    enddate: {

    },
    timelinezoomlevel: {

    },
    header: {
      default: true
    }



	},

  data: function () {
    return {
      colWidth: 10,
      rowHeight: 30
    }
  },

  methods: {
    findDateIndex(DateIndex,DateToFind) {

      var index = DateIndex.findIndex((v) => {
        return new Date(v).getTime()===new Date(DateToFind).getTime();
      });

        return index;
    }


  },
  watch: {


  },
  computed: {

    gridParams () {
      var clone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      var clone1 = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));
      //console.log("what is wrong here",clone1)
      //need to find nearest date
      //if day is < mid month, set day to 1 for current month, else, move to next month and set day==1

      if(this.timelinezoomlevel=="days"){
        console.log("looking for DateIndex")

        var startDate =this.startdate
        var endDate =this.enddate

        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)

        var foundIndex2 = this.findDateIndex(clone,endDate)
        //console.log("startDate",endDate,"@ index", foundIndex2)

        var x1 = foundIndex*this.$store.state.colWidth
        var x2 = (foundIndex2)*this.$store.state.colWidth


      }else{
        //console.log("looking for MonthIndex")
        if(this.startdate.getDate()<15){
          var startDate =new Date(this.startdate.getFullYear(),(this.startdate.getMonth()),1)
          var checkDate =new Date(clone1[0])
          // if(startDate<checkDate){ //need a better soloution here
          //   console.log("uh-oh",checkDate)
          //   startDate=checkDate
          // }

        }else{
          var startDate =new Date(this.startdate.getFullYear(),(this.startdate.getMonth()+1),1)

        }
        if(this.enddate.getDate()<15){
          var endDate =new Date(this.enddate.getFullYear(),(this.enddate.getMonth()),1)

        }else{
          var endDate =new Date(this.enddate.getFullYear(),(this.enddate.getMonth()+1),1)

        }

        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone1,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)

        var foundIndex2 = this.findDateIndex(clone1,endDate)
        //console.log("startDate",endDate,"@ index", foundIndex2)
        if(foundIndex<0){
          console.log("foundIndex uh-oh",startDate,clone[0],clone1[0])
        }
        if(foundIndex2<0){
          console.log("foundIndex2 uh-oh",startDate,clone[0],clone1[0])
          foundIndex2=clone1.length-1
        }
        var x1 = foundIndex*this.$store.state.colWidth
        var x2 = (foundIndex2)*this.$store.state.colWidth
      }


      //console.log("Timeline Col Group x1",x1)
      if(this.Type==1){

        var x = {

          '--ColStart': `${x1}px`,
          '--ColEnd': `${x2}px`,
          '--Width': `${x2-x1}px`,
          '--Height': `${(this.RowEnd-this.RowStart)*this.rowHeight}px`,

          '--RowStart': `${this.RowStart*this.rowHeight}px`,
          '--RowEnd': `${this.RowEnd*this.rowHeight}px`


        }
        //console.log("TimelineGridColGroup Years right her right now",x)


      }else if (this.Type==2) {
        var x = {

          '--ColStart': `${x1}px`,
          '--ColEnd': `${x2}px`,
          '--Width': `${x2-x1}px`,
          '--Height': `${(this.RowEnd-this.RowStart)*this.rowHeight}px`,

          '--RowStart': `${this.RowStart*this.rowHeight}px`,
          '--RowEnd': `${this.RowEnd*this.rowHeight}px`


        }
        //console.log("TimelineGridColGroup Months right her right now",x)

      }else if (this.Type==3) {
        var x = {

          '--ColStart': `${x1}px`,
          '--ColEnd': `${x2}px`,
          '--Width': `${x2-x1}px`,
          '--Height': `${(this.RowEnd-this.RowStart)*this.rowHeight}px`,

          '--RowStart': `${this.RowStart*this.rowHeight}px`,
          '--RowEnd': `${this.RowEnd*this.rowHeight}px`


        }
        //console.log("TimelineGridColGroup Days right her right now",x)

      }

      return x
    },

  }

}
</script>
